import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ymd } from "@/lib/date";

export default function CalendarPage() {
  const [weekStart, setWeekStart] = useState(() => {
    const d = new Date();
    const diff = (d.getDay() + 6) % 7;
    d.setDate(d.getDate() - diff);
    d.setHours(0,0,0,0);
    return d;
  });
  const [appts, setAppts] = useState([]);

  const days = [...Array(7)].map((_, i) => {
    const d = new Date(weekStart);
    d.setDate(d.getDate() + i);
    return d;
  });

  useEffect(() => {
    const from = ymd(days[0]);
    const to = ymd(days[6]);
    api.get("/appointments", { params: { date_from: from, date_to: to, limit: 500 } }).then((r) => setAppts(r.data));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [weekStart]);

  function shift(delta) {
    const d = new Date(weekStart);
    d.setDate(d.getDate() + delta * 7);
    setWeekStart(d);
  }

  const colors = { pending: "bg-amber-100 border-amber-300 text-amber-800", confirmed: "bg-emerald-100 border-emerald-300 text-emerald-800", rescheduled: "bg-sky-100 border-sky-300 text-sky-800", cancelled: "bg-rose-100 border-rose-300 text-rose-800 line-through", completed: "bg-indigo-100 border-indigo-300 text-indigo-800", no_show: "bg-slate-200 border-slate-300 text-slate-700" };

  return (
    <div className="space-y-4" data-testid="calendar-page">
      <div className="flex items-center justify-between flex-wrap gap-2">
        <div>
          <h1 className="text-2xl font-display font-bold text-slate-900">Calendar</h1>
          <p className="text-slate-500 text-sm" data-testid="calendar-week-label">{days[0].toLocaleDateString(undefined,{day:"numeric",month:"short"})} – {days[6].toLocaleDateString(undefined,{day:"numeric",month:"short",year:"numeric"})}</p>
        </div>
        <div className="flex items-center gap-2">
          <button data-testid="calendar-prev-btn" onClick={() => shift(-1)} className="px-3 py-1.5 border border-slate-200 rounded-lg bg-white text-sm">‹ Prev</button>
          <button data-testid="calendar-next-btn" onClick={() => shift(1)} className="px-3 py-1.5 border border-slate-200 rounded-lg bg-white text-sm">Next ›</button>
        </div>
      </div>
      <div className="grid grid-cols-7 gap-2">
        {days.map((d, i) => {
          const iso = ymd(d);
          const dayAppts = appts.filter((a) => a.date === iso).sort((a, b) => a.start_time.localeCompare(b.start_time));
          const isToday = iso === ymd(new Date());
          return (
            <div key={i} className={`bg-white rounded-xl border border-slate-200 p-2 min-h-[200px] ${isToday ? "ring-2 ring-emerald-500/40" : ""}`}>
              <div className="text-[11px] uppercase tracking-wider text-slate-500 font-semibold">{d.toLocaleDateString(undefined, { weekday: "short" })}</div>
              <div className="font-display font-bold text-slate-900">{d.getDate()}</div>
              <div className="mt-2 space-y-1">
                {dayAppts.map((a) => (
                  <div key={a.id} className={`text-xs rounded-md border px-1.5 py-1 ${colors[a.status] || "bg-slate-50"}`}>
                    <div className="font-mono text-[10px]">{a.start_time}</div>
                    <div className="truncate font-medium">{a.patient_name}</div>
                  </div>
                ))}
                {dayAppts.length === 0 && <div className="text-[11px] text-slate-400">—</div>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
